// removed by extract-text-webpack-plugin
module.exports = {"compose-messages":"compose-messages","compose-message-wrapper":"compose-message-wrapper","compose-header":"compose-header","card-wrapper":"card-wrapper","subject":"subject","card-selection-wrapper":"card-selection-wrapper","card-selection":"card-selection","ant-select-selector":"ant-select-selector","card-selection-to":"card-selection-to","sender-wrapper":"sender-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ComposeMessage/ComposeMessages.scss
// module id = 5123
// module chunks = 1